import { appConfig } from "../../insaweb.config";

export module GenericChartsModule {
  const chartColors = appConfig.chartColors;
  let extraLabelOptions = {};

  const stockChartStyle = (appConfig as any).stockChartStyle || {
    useGradient: false,
  };

  /*---------------------Begin Region GenericDonut Chart -------------------------------------*/
  export function KendoInitGenericDonutChart(
    selector,
    chartdata,
    type,
    field,
    description,
    text,
    legendvisible,
    width,
    height,
    selCurr,
    showPercentage = false,
    alwaysVisible = false,
  ) {
    let chartOptions: kendo.dataviz.ui.ChartOptions = {};
    chartOptions.theme = "customInsa";
    if (chartdata.length > 0) {
      chartOptions.chartArea = { background: "", width: width, height: height };
      chartOptions.title = {
        text: text,
        margin: { bottom: 0, left: 0, right: 0, top: 0 },
        padding: { bottom: 0, left: 0, right: 0, top: 0 },
      };
      chartOptions.dataSource = chartdata;
      chartOptions.seriesDefaults = {
        type: type,
        labels: (e) =>
          width < 200 || height < 200 || !showPercentage
            ? donutChartLabelSettings(e)
            : customizedLabelSettings(e, alwaysVisible),
      };
      chartOptions.series = [
        {
          field: field,
          categoryField: description,
          connectors: { color: "transparent" },
        },
      ];
      chartOptions.seriesClick = explodeDonutChartFieldOnClick;
      chartOptions.tooltip = {
        visible: true,
        template: kendo.template(
          "${ category }:  #= kendo.toString(percentage*100, 'n2') + '%'# -  " +
            selCurr +
            " ${ kendo.toString(value, 'n0') }",
        ),
      };
      chartOptions.legend = chartLegend(legendvisible, selCurr);
    } else {
      chartOptions.title = { text: "NO DATA", position: "center" };
      chartOptions.chartArea = { background: "" };
      chartOptions.valueAxis = [
        { visible: false, majorGridLines: { visible: false } },
      ];
      chartOptions.categoryAxis = [
        { line: { visible: false } },
        { line: { visible: false } },
      ];
    }

    let x = $(selector).kendoChart(chartOptions);
  }

  function customizedLabelSettings(e, alwaysVisible): Object {
    let obj: any = donutChartLabelSettings(e);
    obj.visible = alwaysVisible;
    obj.template = kendo.template(
      "${ category }:  #= kendo.toString(percentage*100, 'n2') + '%'#",
    );
    return obj;
  }

  function donutChartLabelSettings(e): Object {
    if (window.innerWidth <= 768) {
      return { visible: false };
    } else {
      return {
        visible: true,
        position: getDonutChartLabelPosition(e.percentage),
        padding: {
          right: e.category.length - 2,
          left: e.category.length,
          top: 1,
          bottom: 1,
        },
        distance: 0,
        text: { position: "center" },
        background: e.series.color,
        color: getDonutChartLabelFontColor(e.series.color),
        template: kendo.template("#= category #"),
        border: { color: e.series.color },
      };
    }
  }

  function getDonutChartLabelPosition(percentage: number): string {
    if (percentage < 0.1) {
      return "outsideEnd";
    } else {
      return "insideEnd";
    }
  }

  function getDonutChartLabelFontColor(color: string): string {
    if (luminance_get(color) > 175) {
      return "black";
    } else {
      return "white";
    }
  }

  function chartLegend(legendVisible: boolean, selCurr: string): Object {
    if (window.innerWidth < 1200) {
      return {
        visible: legendVisible,
        position: "bottom",
        padding: { top: 0, bottom: 80 },
        labels: {
          color: "#222",
          template: kendo.template(
            "#= data.text #: #= kendo.toString(percentage*100, 'n2') + '%'# - " +
              selCurr +
              " #= kendo.toString(data.value, 'n0')#",
          ),
        },
      };
    } else {
      return {
        visible: legendVisible,
        position: "custom",
        offsetX: 150,
        offsetY: 100,
        labels: {
          color: "#222",
          template: kendo.template(
            "#= data.text# \n\n #= kendo.toString(percentage*100, 'n2') + '%'# - " +
              selCurr +
              " #= kendo.toString(data.value, 'n0')#",
          ),
        },
      };
    }
  }

  function explodeDonutChartFieldOnClick(e) {
    if (e.dataItem.explode) {
      e.sender.options.transitions = false;
      e.dataItem.explode = false;
    } else {
      e.sender.options.transitions = false;
      e.dataItem.explode = true;
    }
    e.sender.refresh();
  }
  /*-------------------------------End Region Generic Donut Chart----------------------------------------------*/
  /*-------------------------------Begin Region Generic Bar Chart----------------------------------------------*/
  export function KendoInitGenericBarChart(
    selector,
    chartdata,
    text,
    minVal,
    maxVal,
    secSerieVisibility,
    height,
    legendVisible,
    categoryVisible,
  ) {
    let barChartOptions: kendo.dataviz.ui.ChartOptions = {};
    let dataSourceOptions: kendo.data.DataSourceOptions = {};
    dataSourceOptions.data = chartdata;
    dataSourceOptions.schema = {
      model: {
        fields: {
          Date: { type: "string" },
        },
      },
    };
    let dataSource: kendo.data.DataSource = new kendo.data.DataSource(
      dataSourceOptions,
    );

    if (chartdata !== undefined && chartdata.length > 0) {
      barChartOptions.theme = "customInsa";
      barChartOptions.dataSource = dataSource;
      barChartOptions.chartArea = { background: "", height: height };
      barChartOptions.legend = {
        visible: legendVisible,
        position: "bottom",
        labels: { color: "#222" },
      };
      barChartOptions.seriesDefaults = { spacing: 0 };
      barChartOptions.series = [];
      if (chartdata[0].Description !== "")
        barChartOptions.series.push({
          type: "column",
          name: chartdata[0].Description,
          field: "Value",
        });
      if (chartdata[0].Description2 !== "")
        barChartOptions.series.push({
          type: "line",
          style: "smooth",
          markers: { visible: false },
          name: chartdata[0].Description2,
          field: "Value2",
          color: chartColors[1],
          visible: secSerieVisibility,
        });
      barChartOptions.valueAxis = [
        {
          axisCrossingValue: [0, minVal - 2],
          labels: { format: "{0:n1}%" },
          line: { visible: false },
        },
      ];
      barChartOptions.categoryAxis = [
        { line: { visible: false }, field: "Date", labels: { visible: false } },
        {
          field: "Date",
          line: { visible: false },
          majorGridLines: { visible: false },
          labels: {
            visible: categoryVisible,
            rotation: { angle: -45 },
            template: "#= kendo.toString(new Date(value), 'dd/MM/yyyy') #",
          },
        },
      ];
      barChartOptions.tooltip = {
        visible: true,
        template: "#= kendo.toString(value, 'n2') + '%' #",
      };
    } else {
      barChartOptions.title = { text: "NO DATA", position: "center" };
      barChartOptions.series = [];
      barChartOptions.valueAxis = [
        { visible: false, majorGridLines: { visible: false } },
      ];
      barChartOptions.categoryAxis = [
        { line: { visible: false } },
        { line: { visible: false } },
      ];
      barChartOptions.tooltip = { visible: false };
    }
    $(selector).kendoChart(barChartOptions);
  }

  /*-----------------------------End Region Generic Bar Chart---------------------------------------*/
  /*-----------------------------Begin Region Generic Chart List------------------------------------*/
  export function KendoGenericChartList(selector, listdata, columnDef) {
    let dataSourceOptions: kendo.data.DataSourceOptions = {};
    dataSourceOptions.data = listdata;
    dataSourceOptions.schema = {
      model: {
        fields: {
          Date: { type: "date" },
        },
      },
    };
    let dataSource: kendo.data.DataSource = new kendo.data.DataSource(
      dataSourceOptions,
    );
    let chartListOptions: kendo.ui.GridOptions = {};
    chartListOptions.dataSource = dataSource;
    chartListOptions.columns = columnDef;
    chartListOptions.resizable = true;
    chartListOptions.noRecords = {
      template: "<p class='center no-data-message'>NO DATA</p>",
    };
    if (listdata !== undefined && listdata !== null) {
      if (listdata.length <= 14) {
        chartListOptions.scrollable = false;
      } else {
        chartListOptions.scrollable = true;
      }
    }
    chartListOptions.dataBound = changeRowColor;

    function changeRowColor(e) {
      if (selector === "#PerformanceDetailsList") {
        let grid = $(selector).data("kendoGrid");
        let data = grid.dataSource.data();
        $.each(data, function (i, row) {
          let element = $('tr[data-uid="' + row.uid + '"] ');
          $(element).css("background-color", "transparent");
        });
      } else {
        let grid = $(selector).data("kendoGrid");
        let data = grid.dataSource.data();
        $.each(data, function (i, row) {
          let element = $('tr[data-uid="' + row.uid + '"] ');
          $(element).css("background-color", chartColors[i]);
          $(element).css("color", setChartFontColor()[i]);
        });
      }
      let loading = $(".chartList-loading", e.sender.element.parent());
      kendo.ui.progress(loading, false);
    }
    $(selector).kendoGrid(chartListOptions);
    if (selector !== "#PerformanceDetailsList")
      $(selector + " " + ".k-grid-header").hide();
  }

  function setChartFontColor(): string[] {
    let fontColor = [];
    chartColors.forEach((col) => {
      luminance_get(col) > 175
        ? fontColor.push("black")
        : fontColor.push("white");
    });
    return fontColor;
  }

  function getRGB(b) {
    let a;
    let colors;
    if (b && b.constructor == Array && b.length == 3) return b;
    if (
      (a =
        /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(
          b,
        ))
    )
      return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
    if (
      (a =
        /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(
          b,
        ))
    )
      return [
        parseFloat(a[1]) * 2.55,
        parseFloat(a[2]) * 2.55,
        parseFloat(a[3]) * 2.55,
      ];
    if ((a = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(b)))
      return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
    if ((a = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(b)))
      return [
        parseInt(a[1] + a[1], 16),
        parseInt(a[2] + a[2], 16),
        parseInt(a[3] + a[3], 16),
      ];
    return typeof colors != "undefined"
      ? colors[jQuery.trim(b).toLowerCase()]
      : null;
  }

  function luminance_get(color) {
    let rgb = getRGB(color);
    if (!rgb) return null;
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
  }
  /*----------------------------- End Region Generic Chart List-------------------------------------*/
  /*------------------------------Begin Region Multipane Stock Chart--------------------------------*/
  export function InitKendoGenericMultipaneStockChart(
    selector,
    chartdata,
    typeAbove,
    typeBottom,
    field,
    text,
    titleVisible,
    date,
    navigator,
    minDate,
    maxDate,
    volume,
    minVolume,
    maxVolume,
    height,
    width,
    YseriesCaption = "Price",
  ) {
    let stockChartOptions: kendo.dataviz.ui.StockChartOptions = {};
    let dataSourceOptions: kendo.data.DataSourceOptions = {};
    dataSourceOptions.data = chartdata;
    dataSourceOptions.schema = {
      model: {
        fields: {
          Date: { type: "string" },
        },
      },
    };
    let dataSource: kendo.data.DataSource = new kendo.data.DataSource(
      dataSourceOptions,
    );
    stockChartOptions.theme = "customInsa";

    if (chartdata !== undefined && chartdata.length > 0) {
      let stockChartDate: kendo.dataviz.ui.StockChartNavigatorSelect = {};
      stockChartDate.from = minDate;
      stockChartDate.to = maxDate;
      let dataSource: kendo.data.DataSource = new kendo.data.DataSource(
        dataSourceOptions,
      );
      stockChartOptions.dataSource = dataSource;
      stockChartOptions.dateField = date;

      const tooltipTemplate =
        "Date: #= kendo.format('{0:dd/MM/yyyy}',category) # - " +
        YseriesCaption +
        ": #= (dataItem!==undefined) ? dataItem.SecurityCurrency : ''# #= kendo.toString(data.value, 'n2')#";

      if (stockChartStyle.useGradient) {
        const style = stockChartStyle;

        stockChartOptions.chartArea = {
          background: style.chartBackground,
          height: height,
          width: width,
        };

        const areaSeries: any = {
          type: "area",
          missingValues: "interpolate",
          name: chartdata[0].SecurityName,
          field: field,
          color: style.areaColor,
          opacity: style.areaOpacity,
          line: { color: style.areaLineColor, width: style.areaLineWidth },
          overlay: { gradient: "none" },
          tooltip: { template: tooltipTemplate },
        };

        if (window.innerWidth < 1200 || appConfig.hideSecurityPricesVolume) {
          // Mobile / tablet
          stockChartOptions.panes = [{ title: { text: YseriesCaption } }];
          stockChartOptions.valueAxis = [
            {
              labels: {
                format: "{0}",
                color: style.valueAxisLabelColor || "#000",
              },
              line: { visible: false },
              padding: { right: 1 },
            },
            { name: "volumeAxis", pane: "volumePane", visible: false },
          ];
          stockChartOptions.series = [areaSeries];
          stockChartOptions.categoryAxis = [
            {
              crosshair: {
                width: 1,
                visible: stockChartStyle.crossHairVisible,
              },
              baseUnit: "fit",
              labels: {
                visible: stockChartStyle.categoryAxisVisible,
                color: style.categoryAxisLabelColor,
                rotation: 0,
                template: "#= kendo.toString(new Date(value), 'dd/MM/yyyy') #",
              },
            },
          ];
          stockChartOptions.navigator = {
            visible: window.innerWidth >= 768 ? true : false,
            series: [
              {
                type: style.navigatorType,
                field: field,
                missingValues: "interpolate",
                color: style.navigatorColor,
                opacity: style.navigatorOpacity,
                width: 1,
                line: { color: style.navigatorColor, width: 1 },
              },
            ],
            select: stockChartDate,
          };
        } else {
          // Desktop
          stockChartOptions.panes = [
            {
              title: { text: YseriesCaption },
              background: style.paneBackground,
              border: { width: 0 },
            },
          ];
          stockChartOptions.valueAxis = [
            {
              line: { visible: false },
              labels: {
                format: "{0}",
                color: style.valueAxisLabelColor || "#000",
              },
              majorGridLines: { color: style.gridLineColor },
              padding: { right: 1 },
            },
            {
              name: "volumeAxis",
              pane: "volumePane",
              visible: false,
              majorGridLines: { visible: false },
            },
          ];
          stockChartOptions.categoryAxis = [
            {
              crosshair: {
                width: 1,
                visible: stockChartStyle.crossHairVisible,
              },
              baseUnit: "fit",
              line: { visible: false },
              majorGridLines: { visible: false },
              labels: {
                visible: stockChartStyle.categoryAxisVisible,
                color: style.categoryAxisLabelColor,
                rotation: 0,
                template: "#= kendo.toString(new Date(value), 'dd/MM/yyyy') #",
              },
            },
          ];
          stockChartOptions.series = [areaSeries];
          stockChartOptions.navigator = {
            visible: true,
            series: [
              {
                type: style.navigatorType,
                field: field,
                missingValues: "interpolate",
                color: style.navigatorColor,
                opacity: style.navigatorOpacity,
                width: 1,
                line: { color: style.navigatorColor, width: 1 },
              },
            ],
            select: stockChartDate,
            pane: { background: style.paneBackground, border: { width: 0 } },
            hint: { visible: false },
          };
        }

        const applyGradient = function () {
          const chartEl = document.querySelector(selector);
          if (!chartEl) return;
          const svg = (chartEl as Element).querySelector("svg");
          if (!svg) return;

          const oldDefs = svg.querySelector("#insaGradientDefs");
          if (oldDefs) oldDefs.remove();

          const defsEl = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "defs",
          );
          defsEl.id = "insaGradientDefs";
          defsEl.innerHTML =
            '<linearGradient id="insaAreaGrad" x1="0" y1="0" x2="0" y2="1">' +
            style.gradientStops
              .map(
                (s) =>
                  `<stop offset="${s.offset}" stop-color="${s.color}" stop-opacity="${s.opacity}"/>`,
              )
              .join("") +
            "</linearGradient>";
          svg.insertBefore(defsEl, svg.firstChild);

          svg.querySelectorAll("path").forEach((p: any) => {
            if (p.getAttribute("fill") === style.areaColor) {
              p.setAttribute("fill", "url(#insaAreaGrad)");
            }
          });
        };

        (stockChartOptions as any).render = function () {
          setTimeout(applyGradient, 0);
        };

        $(selector).kendoStockChart(stockChartOptions);
        kendo.ui.progress($(".stockChart-loading"), false);

        const chartInstance = $(selector).data("kendoStockChart");
        if (chartInstance) {
          chartInstance.bind("render", function () {
            setTimeout(applyGradient, 0);
          });
          chartInstance.bind("dataBound", function () {
            setTimeout(applyGradient, 0);
          });
        }

        setTimeout(() => {
          const chartEl = document.querySelector(selector);
          if (!chartEl) return;
          const svg = (chartEl as Element).querySelector("svg");
          if (!svg) return;
          const observer = new MutationObserver(() => {
            const s = (
              document.querySelector(selector) as Element
            )?.querySelector("svg");
            if (!s) return;
            s.querySelectorAll("path").forEach((p: any) => {
              if (p.getAttribute("fill") === style.areaColor) {
                p.setAttribute("fill", "url(#insaAreaGrad)");
              }
            });
          });
          observer.observe(svg, {
            subtree: true,
            attributes: true,
            attributeFilter: ["fill"],
            childList: true,
          });
        }, 500);
      } else {
        stockChartOptions.chartArea = {
          background: "",
          height: height,
          width: width,
        };

        const areaSeries: any = {
          type: "area",
          missingValues: "interpolate",
          name: chartdata[0].SecurityName,
          field: field,
          tooltip: { template: tooltipTemplate },
        };

        if (window.innerWidth < 1200 || appConfig.hideSecurityPricesVolume) {
          // Mobile / tablet
          stockChartOptions.panes = [{ title: { text: YseriesCaption } }];
          stockChartOptions.valueAxis = [
            {
              labels: { format: "{0}" },
              line: { visible: false },
              padding: { right: 1 },
            },
            { name: "volumeAxis", pane: "volumePane", visible: false },
          ];
          stockChartOptions.series = [areaSeries];
          stockChartOptions.categoryAxis = [
            {
              crosshair: { width: 1, visible: true },
              baseUnit: "fit",
              labels: {
                visible: true,
                rotation: -45,
                template: "#= kendo.toString(new Date(value), 'dd/MM/yyyy') #",
              },
            },
          ];
          stockChartOptions.navigator = {
            visible: window.innerWidth >= 768 ? true : false,
            series: [
              { type: "line", field: field, missingValues: "interpolate" },
            ],
            select: stockChartDate,
          };
        } else {
          // Desktop
          stockChartOptions.panes = [{ title: { text: YseriesCaption } }];
          stockChartOptions.valueAxis = [
            {
              line: { visible: false },
              labels: { format: "{0}", color: "#686868" },
              majorGridLines: { visible: true },
              padding: { right: 1 },
            },
            {
              name: "volumeAxis",
              pane: "volumePane",
              visible: false,
              majorGridLines: { visible: false },
            },
          ];
          stockChartOptions.categoryAxis = [
            {
              baseUnit: "fit",
              line: { visible: false },
              majorGridLines: { visible: false },
              labels: {
                visible: true,
                rotation: -45,
                template: "#= kendo.toString(new Date(value), 'dd/MM/yyyy') #",
              },
            },
          ];
          stockChartOptions.series = [areaSeries];
          stockChartOptions.navigator = {
            visible: true,
            series: [
              { type: "line", field: field, missingValues: "interpolate" },
            ],
            select: stockChartDate,
            hint: { visible: false },
          };
        }

        $(selector).kendoStockChart(stockChartOptions);
        kendo.ui.progress($(".stockChart-loading"), false);
      }
    }
  }

  export function KendoInitTimeIntervalPickerForSecPrices(
    selector,
    minDate,
    maxDate,
  ) {
    $("#select-period").kendoMobileButtonGroup({
      select: function (e) {
        let chart: any;
        chart = $(selector).data("kendoStockChart");
        chart._navigator.options.select.from = minDate;
        chart._navigator.options.select.to = maxDate;

        if (e.index === 3) {
          chart._navigator.options.select.from = new Date(
            new Date().getFullYear(),
            0,
            new Date().getDay(),
          );
        } else if (e.index === 1) {
          chart._navigator.options.select.from = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 3,
            new Date().getDay(),
          );
        } else if (e.index === 2) {
          chart._navigator.options.select.from = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 6,
            new Date().getDay(),
          );
        } else if (e.index === 4) {
          chart._navigator.options.select.from = new Date(
            new Date().getFullYear() - 1,
            new Date().getMonth(),
            new Date().getDay(),
          );
        } else if (e.index === 5) {
          chart._navigator.options.select.from = new Date(
            new Date().getFullYear() - 2,
            new Date().getMonth(),
            new Date().getDay(),
          );
        } else if (e.index === 6) {
          chart._navigator.options.select.from = minDate;
          chart._navigator.options.select.to = maxDate;
        } else {
          chart._navigator.options.select.from = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDay(),
          );
        }
        chart.redraw();
      },
      index: 6,
    });
  }
  /*---------------------------------End Region Multipane Stock Chart-------------------------------------------*/
}



// WEBPACK FOOTER //
// ./app/insa-custom-scripts/generic-charts.ts